/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class RenderSequenceFeature
 * @hideconstructor
 * @classdesc
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./impl/RenderSequenceImpl',
	'./api/RenderSequenceAPI',
	'./api/internal/RenderSequenceInternalAPI'
], (APIFactory, RenderSequenceImpl, RenderSequenceAPI, RenderSequenceInternalAPI) => {
	class RenderSequenceFeature {

		/**
		 * TODO: remove the usage of internalAPI.__imp when the internal API mechanism is in place
		 * @param {Object} options 
		 * @param {DashboardAPI} options.dashboardAPI
		 * @param {ContentAPI} options.content
		 */
		constructor(options) {
			let impl = new RenderSequenceImpl(options);
			this._publicAPI = APIFactory.createAPI(impl, [RenderSequenceAPI]);
			this._internalAPI = APIFactory.createAPI(impl, [RenderSequenceAPI, RenderSequenceInternalAPI]);
		}

		getAPI(type) {
			if(type === 'internal') {
				return this._internalAPI;
			} else {
				return this._publicAPI;
			}
		}
	}

	return RenderSequenceFeature;
});